import { loadGenesysScript } from './genesys-script';

const genesysTriggerElementId = 'xc-genesys';
export const GENESYS_SESSION_KEY = 'genesys-screen-share-active';
const ACTIVE_SESSION_COLOR = '#ea650d';

function bindGenesysTrigger() {
  const trigger = document.getElementById(genesysTriggerElementId);

  if (!trigger || trigger.dataset.genesysBound === 'true') {
    return;
  }

  const triggerLink =
    trigger.querySelector('a') || trigger;

  triggerLink.addEventListener('click', function (event) {
    event.preventDefault();
    initGenesys();
  });

  trigger.dataset.genesysBound = 'true';
}

// Subscribes to a Genesys event
function subscribeToEvent(eventName, callback) {
  if (typeof window === 'undefined' || !window.Genesys) {
    return;
  }

  window.Genesys('subscribe', eventName, callback);
}

// Dispatches a command to the Genesys
function dispatchCommand(command) {
  if (typeof window === 'undefined' || !window.Genesys) {
    return;
  }

  window.Genesys('command', command);
}

// Hides the Genesys launcher icon from the page
function hideGenesysIcon() {
  dispatchCommand('Launcher.hide');
}

// Sets color for page wrapper when session is active
function setPageWrapperColor() {
  if (typeof document === 'undefined') {
    return;
  }

  const wrapper = document.getElementById('gcobrowse-border');
  if (wrapper) {
    wrapper.style.borderColor = ACTIVE_SESSION_COLOR;
  }
}

// Opens the Genesys Messenger widget and updates the open state flag
function openMessenger() {
  dispatchCommand('Messenger.open');
  window._genesysMessengerOpen = true;
}

// Closes the Genesys Messenger widget if it's currently open and updates the state flag
function closeMessenger() {
  if (window._genesysMessengerOpen) {
    dispatchCommand('Messenger.close');
    window._genesysMessengerOpen = false;
  }
}

export function isGenesysScreenShareActive() {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.sessionStorage.getItem(GENESYS_SESSION_KEY) === 'true';
}

/**
 * Shows the Genesys launcher icon and opens the messenger after a short delay
 * The delay ensures the launcher is visible before the messenger opens
 */
function showGenesysIcon() {
  dispatchCommand('Launcher.show');

  if (isGenesysScreenShareActive()) {
    return;
  }

  setTimeout(() => {
    openMessenger();
  }, 550);
}

// Initializes Genesys event tracking and sets up listeners for messenger and co-browse events
export function initGenesysTracking() {
  if (
    typeof window === 'undefined' ||
    !window.Genesys ||
    window._genesysInitialized
  ) {
    return;
  }

  // Set a flag to prevent multiple initializations
  window._genesysInitialized = true;

  // Subscribe to Messenger open event to update the open state flag
  subscribeToEvent('Messenger.opened', () => {
    window._genesysMessengerOpen = true;
  });

  // Subscribe to Messenger close event to update the open state flag
  subscribeToEvent('Messenger.closed', () => {
    window._genesysMessengerOpen = false;
  });

  // Subscribe to session start event to set a flag indicating an active screen share session
  subscribeToEvent('CobrowseService.sessionStarted', () => {
    window.sessionStorage.setItem(GENESYS_SESSION_KEY, 'true');
    setPageWrapperColor();
  });

  // Subscribe to session end event to clear the active screen share flag and close the messenger
  subscribeToEvent('CobrowseService.sessionEnded', () => {
    window.sessionStorage.removeItem(GENESYS_SESSION_KEY);

    closeMessenger();
    hideGenesysIcon();
  });
}

/**
 * Initializes the Genesys on the page
 * If it's already loaded we show messenger icon
 */
export function initGenesys() {
  if (typeof window === 'undefined') {
    return;
  }

  if (window._genesysJs) {
    showGenesysIcon();
    return;
  }

  // load the Genesys script
  loadGenesysScript();

  window.Genesys('subscribe', 'Messenger.ready', () => {
    initGenesysTracking();
  });

  window.Genesys('subscribe', 'Launcher.ready', () => {
    showGenesysIcon();
  });
}

export function initGenesysTrigger() {
  if (typeof window === 'undefined') {
    return;
  }

  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', bindGenesysTrigger);
  } else {
    bindGenesysTrigger();
  }
}